const labJson = require("./data/dbLab.json");
const RuntimeTrainerData = require("./RuntimeTrainerData");
const _ = require("lodash");

// Internal helper
const cleanNameForURL = function(name) {
	if (!name) return name;
	name = _.toLower(name.split(" ").join("-"));
	name = name.replace(/[?!.\/+="'`$%(){}\[\]]/g, "");
	return name;
};

/**
 * Fetches the plain English type name from the database typeID key. Cached for
 * performance reasons, as this was run hundreds to thousands of times on the
 * Lab Page.
 *
 * Note: This function is used in URLMake, which is in /shared
 * so we want to keep this in a /shared file, too.
 */
let cachedIDToTypeName;
const getTypeNameFromID = function(typeID) {
	/*
	 * Build a typeID => displayName mappping in memory.
	 * Assumption: this is static.
	 */
	if (!cachedIDToTypeName) {
		cachedIDToTypeName = {};
		_.each(
			labJson.puzzleTypes,
			t => (cachedIDToTypeName[t.id] = t.displayName)
		);
	}

	// for cache miss, fetch
	if (!cachedIDToTypeName.hasOwnProperty(typeID)) {
		cachedIDToTypeName[typeID] =
			labJson.puzzleTypes.find(entry => entry.id === typeID)?.displayName || "";
	}

	return cachedIDToTypeName[typeID];
};

const getTypeNameForURL = function(typeID) {
	return cleanNameForURL(getTypeNameFromID(typeID));
};

const getBlockNameFromID = function(blockID) {
	const puzzleBlocks = RuntimeTrainerData.getPuzzleBlocks();
	const block = _.find(puzzleBlocks, t => t.id === blockID);
	if (block) return block.displayName;
	else return null;
};

const getBlockNameForURL = function(blockID) {
	return cleanNameForURL(getBlockNameFromID(blockID));
};

const getActiveTypeIDs = function() {
	return labJson.puzzleTypes.filter(t => !t.underConstruction).map(o => o.id);
};

const getCelestialFromID = function(id) {
	return _.find(labJson.celestials, c => c.id === id);
};

// Returns an object where keys are celestial IDs and values are celestial hashes.
const getCelestialIDToHashMap = function() {
	const mapping = {};
	_.each(labJson.celestials, c => (mapping[c.id] = c.hash));
	return mapping;
};

// Returns an array of all celestial hashes.
const getCelestialHashes = function() {
	return _.map(labJson.celestials, c => c.hash);
};

const getCelestialHashFromID = function(id) {
	const c = getCelestialFromID(id);
	return c && c.hash;
};

module.exports = {
	getTypeNameFromID,
	getTypeNameForURL,
	getBlockNameFromID,
	getBlockNameForURL,
	getActiveTypeIDs,
	getCelestialFromID,
	getCelestialIDToHashMap,
	getCelestialHashes,
	getCelestialHashFromID,
};
